import { giphyIndigo, giphyLightCharcoal, giphyWhite } from '@giphy/js-brand'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { getUser } from 'shared/redux/reducers'
import { LoggedInUser } from 'shared/types/user'
import { trackPageView } from 'shared/util/analytics'
import styled, { css } from 'styled-components'
import Footer from '../shared/components/footer'
import Header from '../shared/components/header'
import SupportCTA from '../shared/components/support-cta'
import { ICapture, IPending } from '../shared/types'
import API from '../shared/utils/api'
import watcher from '../shared/utils/capture-watcher'
import CaptureTable from './capture-table'
import NewCapture from './new-capture'
import Welcome from './welcome'

const api = new API()

const TabsBar = styled.div`
    padding: 40px 0 0 0;
`

const BottomBar = styled.div`
    left: 0;
    bottom: 0;
    height: 100px;
    width: 100%;
    background: linear-gradient(transparent, black);
    margin: 100px 0px -80px;
`

const CountLabel = styled.span`
    border-radius: 4px;
    padding: 1px 4px;
    font-size: 12px;
    background-color: ${giphyIndigo};
    color: ${giphyWhite};
    display: inline-block;
    vertical-align: top;
    height: 17px;
    line-height: 17px;
`

const TabLabel = styled.div<{ active: boolean }>`
    cursor: pointer;
    color: ${giphyLightCharcoal};
    font-size: 17px;
    display: inline;
    margin-right: 20px;

    ${props =>
        props.active &&
        css`
            color: ${giphyWhite};
            font-weight: bold;
        `}
`
type Props = {
    loggedInUser: LoggedInUser
}

const Home = ({ loggedInUser }: Props) => {
    const [captures, setCaptures] = useState([] as ICapture[])
    const [pending, setPending] = useState([] as IPending[])
    const [allCaptures, setAllCaptures] = useState([] as ICapture[])
    const [allPending, setAllPending] = useState([] as IPending[])
    const [isLoading, setIsLoading] = useState(true)
    const [activeTab, setActiveTab] = useState('mine')

    useEffect(() => {
        trackPageView('/supercut')
        fetchCaptures()
        watcher.addListener(onCaptureComplete)

        return () => {
            watcher.removeListener(onCaptureComplete)
        }
    }, [])

    const onCaptureComplete = () => {
        fetchCaptures()
    }

    const fetchCaptures = async () => {
        const r = await api.getCaptures()
        setCaptures(r.captures)
        setPending(r.pending)

        if (loggedInUser.isStaff) {
            const r2 = await api.getAllCaptures()
            setAllCaptures(r2.captures)
            setAllPending(r2.pending)
        }

        setIsLoading(false)
    }

    const onCaptureAdded = uuid => {
        watcher.add(uuid)
        fetchCaptures()
    }

    if (isLoading) {
        return null
    }

    return (
        <div>
            <Header />
            <div>
                {captures.length === 0 && <Welcome />}
                <NewCapture onCaptureAdded={onCaptureAdded} />
                {loggedInUser.isStaff && (
                    <TabsBar>
                        <TabLabel onClick={() => setActiveTab('mine')} active={activeTab === 'mine'}>
                            My Captures <CountLabel>{captures.length + pending.length}</CountLabel>
                        </TabLabel>
                        <TabLabel onClick={() => setActiveTab('all')} active={activeTab === 'all'}>
                            All Captures <CountLabel>{allCaptures.length + allPending.length}</CountLabel>
                        </TabLabel>
                    </TabsBar>
                )}
                <CaptureTable
                    captures={activeTab === 'mine' ? captures : allCaptures}
                    pending={activeTab === 'mine' ? pending : allPending}
                    onCaptureDeleted={() => fetchCaptures()}
                />
            </div>
            <SupportCTA />
            <BottomBar>
                <Footer />
            </BottomBar>
        </div>
    )
}

export default connect(state => ({ loggedInUser: getUser(state) }), {})(Home)
